import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Lock } from 'lucide-react';
export function FinalCTA() {
  return <section id="precio" className="py-24 px-4 bg-navy-900 relative overflow-hidden" data-id="element-44">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[600px] h-[600px] bg-brand-orange/10 rounded-full blur-[100px] pointer-events-none" data-id="element-45"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800 p-8 md:p-12 rounded-3xl border-2 border-brand-orange/30 shadow-[0_0_50px_rgba(232,130,12,0.15)]" data-id="element-47">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-white" data-id="element-48">
            Recupera tu autoridad metabólica hoy mismo.
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-49">
            No permitas que un diagnóstico evitable dicte el resto de tu vida.
            Obtén el sistema completo "El Código de Insulina 55+" por un pago
            único.
          </p>

          <div className="mb-10" data-id="element-50">
            <span className="text-gray-400 line-through text-2xl mr-4" data-id="element-51">
              $19.99
            </span>
            <span className="text-5xl font-black text-brand-light" data-id="element-52">$6.39</span>
            <span className="text-gray-400 ml-2" data-id="element-53">USD</span>
            <span className="inline-block bg-red-500 text-white font-bold text-sm px-3 py-1 rounded-full ml-3 align-middle" data-id="element-54">
              68% OFF
            </span>
          </div>

          <CTAButton className="w-full md:w-auto md:px-12 py-5 text-xl mb-6" onClick={() => window.open('https://www.mejorenfoque.com/cart/51221408940317:1', '_blank')} data-id="element-55" />

          <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 mt-8 text-gray-400" data-id="element-56">
            <div className="flex items-center" data-id="element-57">
              <Lock className="w-5 h-5 mr-2 text-green-500" data-id="element-58" />
              <span data-id="element-59">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center" data-id="element-60">
              <ShieldCheck className="w-5 h-5 mr-2 text-green-500" data-id="element-61" />
              <span data-id="element-62">Entrega inmediata por correo</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}